import { useCallback, useState } from "react";
import { toast } from "sonner";
import api, { apiErrorMessage } from "@/lib/api";

// Batas & format harus sejalan dengan qr-backend/server.py (MAX_UPLOAD_MB, IMAGE_CONTENT_TYPES)
export const MAX_IMAGE_MB = Number(process.env.REACT_APP_MAX_UPLOAD_MB) || 5;
export const IMAGE_ACCEPT = ".jpg,.jpeg,.png,.gif,.webp";
export const UPLOAD_HINT = `JPG / PNG / GIF / WEBP \u2022 maks ${MAX_IMAGE_MB} MB`;
const ACCEPTED_EXT = ["jpg", "jpeg", "png", "gif", "webp"];

/** Return pesan error validasi, atau string kosong bila file lolos pemeriksaan. */
export function imageValidationError(file) {
  if (!file) return "Tidak ada file yang dipilih.";
  const name = file.name || "";
  const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
  if (ext && !ACCEPTED_EXT.includes(ext)) {
    return "Format gambar tidak didukung. Gunakan JPG, PNG, GIF, atau WEBP.";
  }
  if (!(file.type || "").startsWith("image/")) return "File yang diunggah harus berupa gambar.";
  if (!file.size) return "File kosong, silakan pilih gambar lain.";
  if (file.size > MAX_IMAGE_MB * 1024 * 1024) return `Ukuran gambar maksimal ${MAX_IMAGE_MB} MB.`;
  return "";
}

/**
 * Pola seragam untuk semua upload gambar admin:
 * reset input -> validasi -> POST /upload?folder=... -> toast sukses/error.
 *
 * const { uploading, upload } = useImageUpload();
 * <input type="file" accept={IMAGE_ACCEPT} disabled={uploading}
 *        onChange={(e) => upload(e, { folder: "logo", onUploaded: setId })} />
 */
export function useImageUpload() {
  const [uploading, setUploading] = useState(false);

  const upload = useCallback(async (event, options = {}) => {
    const { folder = "menu", onUploaded, successMessage = "Gambar terupload" } = options;
    const input = event?.target;
    const file = input?.files?.[0];
    // reset supaya file yang sama tetap bisa dipilih ulang setelah gagal/berhasil
    if (input) input.value = "";
    if (!file) return null;

    const invalid = imageValidationError(file);
    if (invalid) {
      toast.error(invalid);
      return null;
    }

    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/upload?folder=${folder}`, fd);
      onUploaded?.(data.id);
      if (successMessage) toast.success(successMessage);
      return data.id;
    } catch (err) {
      toast.error(apiErrorMessage(err, "Upload gagal, coba lagi"));
      return null;
    } finally {
      setUploading(false);
    }
  }, []);

  return { uploading, upload };
}

export default useImageUpload;
